import React from 'react';
import i18n from '../../../i18n/i18n';

import { PublicRoute } from '../../../utils/routes';

const RentOutBanner = () => {
  return (
    <div className="w-full bg-[url('./images/owners/rent-out-background.png')] bg-[length:100%] bg-center bg-cover bg-no-repeat p-[25px] md:py-[30px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center mt-[50px] mb-[40px] md:mt-[80px]">
        <div className="text-[35px] text-white font-bold text-center md:text-[45px]">{i18n.t("owners.rentOutBanner.title")}</div>
        <div className="mt-[10px] text-[15px] text-white text-center md:text-[18px]">{i18n.t("owners.rentOutBanner.description")}</div>
        <a href={PublicRoute.AddListing}>
          <div className="bg-white justify-center my-[50px] px-[20px] py-[10px] text-primary900 text-[14px] font-bold text-center rounded-[5px] cursor-pointer">
            {i18n.t("owners.rentOutBanner.rentSpace").toUpperCase()}
          </div>
        </a>
      </div>
    </div>
  )
}

export default RentOutBanner;